module.exports = __webpack_public_path__ + "img/Fidelity Bank Nigeria.9709491a.png";